import { ActionType, createAction } from "typesafe-actions";

import { AnyEntity, AnyEntityId, EntityType } from "@mapmycustomers/shared/types/entity";

export interface UiSyncListener<T extends AnyEntity = AnyEntity> {
  onAdd?: (entityType: EntityType, entities: T[]) => void;
  onDelete?: (entityType: EntityType, entitiesIds: T["id"][]) => void;
  onRestore?: (entityType: EntityType, entities: T[]) => void;
  onUpdate?: (
    entityType: EntityType,
    entities: T[],
    possiblyOtherRecordsAffected?: boolean
  ) => void;
}

export const subscribe = createAction("@uiSync/subscribe")<{
  entityTypes: EntityType[];
  listener: UiSyncListener;
}>();

export const unsubscribe = createAction("@uiSync/unsubscribe")<{
  entityTypes: EntityType[];
  listener: UiSyncListener;
}>();

export const notifyAboutChanges = createAction("@uiSync/notifyAboutChanges")<{
  added?: AnyEntity[];
  deletedIds?: AnyEntityId[];
  entityType: EntityType;
  // primary use case for activities, when updating one recurring activity may
  // affect other activity records
  possiblyOtherRecordsAffected?: boolean;
  restored?: AnyEntity[];
  updated?: AnyEntity[];
  updatedIds?: AnyEntity["id"][];
}>();

export type Actions = ActionType<typeof notifyAboutChanges | typeof subscribe | typeof unsubscribe>;
